module.exports = __webpack_public_path__ + "static/media/patron_app_icon.ea8701ca.svg";